
/**
 * CreditCard model
 * Used by PaymentProvider
 */
export class CreditCard {
    number: number;
    cvc: string;
    holderName: string;
    expiryMonth: number;
    expiryYear: number;
    generationtime: string;
    productID: number;

    constructor(object: any = {}) {
        this.number = object && object.number || null;
        this.cvc = object && object.cvc || null;
        this.holderName = object && object.holderName || null;
        this.expiryMonth = object && object.expiryMonth || null;
        this.expiryYear = object && object.expiryYear || null;
        this.generationtime = object && object.generationtime || null;
        this.productID = object && object.productID || null;
    }
    isEmpty(): boolean {
        return !this.number;
    }
    getPaymentMethodName(): string {
        return 'CREDIT_CARD';
    }
    /**
     * Return the expiry date as a string
     * @returns expiryDate in mm/yy format
     */
    getExpiryDate(): string {
        return `${this.expiryMonth}/${this.expiryYear}`;
    }
    /**
     * Return the validity of the full-format creditCard
     */
    isFullyCompleted(): boolean {
        return !!this.number &&
            !!this.cvc &&
            this.cvc.length === 3 &&
            !!this.holderName &&
            !!this.expiryMonth &&
            !!this.expiryYear &&
            !!this.productID;
    }
}
